// Vuex
import store from '@/store.js';

import Request from './request';
import consts from "@/consts.js";

async function fetchAll() {
  return Request('get', "api/districts");
}

async function fetch(data) {
  return Request('get', "api/districts",data);
}
async function fetchAllForSelect(data) {
  if (!data) data = {};
  data.limit = consts.limitAll; //获取全部
  return Request('get', "api/districts/select", data, false, false, true);
}

async function tree(data) {
  const response = await Request('get', "api/districts/tree", data);
  if (response.data && response.data.status.isOK()) {
    store.commit("serverDistricts", response.data.districts);
  }
  return response;
}

async function save(id, data) {
  if (id) {
    return Request('post', "api/districts/edit?id=" + id, data);
  } else {
    return Request('post', "api/districts/add", data);
  }
}

async function del(id) {
  return Request('get', "api/districts/delete/", id ? { id: id } : {});
}

export default {
  fetch,
  fetchAll,
  fetchAllForSelect,
  tree,
  save,
  del,
};